import $ from 'jquery';
import 'select2';

export const WORK_HOURS_CONFIG = {
  startHour: 6,
  endHour: 22,
  allowedTypes: [0, 2],
  get warningMessage() {
    return `⚠️ Atenció: Hores extraordinàries!\n` +
           `Hi ha imputació fora d'horari (${this.startHour}:00 i ${this.endHour}:00) amb un tipus hora "Diürna" o "Desplaçament".\n` +
           `Si són hores extraordinàries, assegura\'t que el tipus sigui "Nocturna / Festiva".`;
  }
};

// Cache DOM elements for better performance
let $workOrderFormContainers = null;
let $workOrderItemRows = null;
let $totalHoursCalc = null;
let formCounter = 0; // Counter for unique form IDs

function cacheForms() {
  $workOrderFormContainers = $('.work-order-form-container');
  $workOrderItemRows = $('.work-order-item-form');
  $totalHoursCalc = $('.total-hores-calc._js');
}

// Debounce validation for rapid changes
let validationTimeout;
function scheduleValidation($container) {
  clearTimeout(validationTimeout);
  validationTimeout = setTimeout(() => {
    set_total_time($container);
  }, 300);
}

function clearSelect2State($container) {
  // More aggressive cleanup of Select2 artifacts
  $container.find('select').each(function() {
    const $sel = $(this);
    // Remove all select2-related classes and attributes
    $sel.removeClass('select2-hidden-accessible select2');
    $sel.removeAttr('data-select2-id tabindex aria-hidden style');
    $sel.removeData('select2');

    // Destroy if initialized
    if (typeof $.fn.select2 === 'function' && $sel.data('select2')) {
      try {
        $sel.select2('destroy');
      } catch (e) {
        // ignore destroy errors
      }
    }
  });

  // Remove all select2 DOM elements with more specific selectors
  $container.find('.select2-container, .select2, .select2-dropdown, .select2-selection, .select2-selection__rendered, .select2-selection__arrow, .select2-selection__clear, .select2-search, .select2-search__field, .select2-results, .select2-results__options').remove();
  $container.find('[data-select2-id]').removeAttr('data-select2-id');
  $container.find('[aria-labelledby]').removeAttr('aria-labelledby');
  $container.find('[aria-expanded]').removeAttr('aria-expanded');
}

function set_total_time($container) {
  const calculateForContainer = (container) => {
    const $container = $(container);
    let totalMins = 0;

    $container.find('.work-order-item-form').each(function() {
      totalMins += get_mins(this);
    });

    const hours = Math.floor(totalMins / 60);
    const minutes = totalMins % 60;
    const $totalNode = $container.find('.total-hores-calc._js');

    if ($totalNode.length) {
      $totalNode.text(`${hours}h ${('0' + minutes).slice(-2)}m`);
    }
  };

  if ($container && $container.length) {
    calculateForContainer($container);
  } else if ($workOrderFormContainers && $workOrderFormContainers.length) {
    $workOrderFormContainers.each(function() {
      calculateForContainer(this);
    });
  } else if ($totalHoursCalc && $totalHoursCalc.length) {
    // Fallback for forms without explicit wrapper
    $totalHoursCalc.each(function() {
      const $calc = $(this);
      const $nearest = $calc.closest('.work-order-form-container, .custom-crud-body-form, .container-fluid');
      if ($nearest.length) {
        calculateForContainer($nearest);
      }
    });
  }
}

export default function addWorkOrder() {
  // Initial cache
  cacheForms();

  // Initialize existing form project change handlers
  $workOrderFormContainers.each(function() {
    bindProjectChange($(this));
  });

  // Maintain submit buttons enabled/disabled state based on number of forms
  const updateSubmitButtonState = () => {
    const totalForms = $('.work-order-form-container').length;
    const $submits = $('.work-order-form-container').find('input[type="submit"], button[type="submit"]');

    if (totalForms > 1) {
      $submits.prop('disabled', true);
    } else {
      $submits.prop('disabled', false);
    }
  };

  // Use event delegation for dynamic elements and avoid duplicate handlers if init runs more than once
  $(document)
    .off('click', '.add-work-order')
    .off('click', '.add-work-center')
    .off('click', '.add-work-order-form')
    .off('click', '.remove-work-order-form')
    .off('click', '.remove-work-center')
    .off('change', '.mutually-exclusive-checkbox')
    .off('change', '.time_work_order')
    .on('click', '.add-work-order', function(e) {
      e.preventDefault();
      const $currentForm = $(this).closest('.work-order-form-container');
      add_new_input_row('work-order', 'work_order[work_order_items_attributes]', $currentForm);
    })
    .on('click', '.add-work-center', function(e) {
      e.preventDefault();
      add_new_input_row('work-center', 'client[work_centers_attributes]');
    })
    // Add entire form container
    .on('click', '.add-work-order-form', function(e) {
      e.preventDefault();
      if ($(this).prop('disabled')) return;
      $(this).prop('disabled', true);
      add_new_form_container();
      updateSubmitButtonState();
      setTimeout(() => $(this).prop('disabled', false), 1000);
    })
    // Remove form container
    .on('click', '.remove-work-order-form', function(e) {
      e.preventDefault();
      $(this).closest('.work-order-form-container').remove();
      updateSubmitButtonState();
    })
    .on('change', '.mutually-exclusive-checkbox', function() {
      if (this.checked) {
        $('.mutually-exclusive-checkbox').not(this).prop('checked', false);
      }
    })
    .on('change', '.time_work_order', function() {
      scheduleValidation($(this).closest('.work-order-form-container'));
    })
    .on('click', '.remove-work-center', function(e) {
      e.preventDefault();
      const imgElement = $(this);
      const parentDiv = imgElement.closest('[id^="work-center-item-form_"]');
      const parentDivId = parentDiv.attr('id');
      const elementId = parentDivId.split('_').pop();

      parentDiv.remove();
      const hiddenElement = $('#client_work_centers_attributes_' + elementId + '_id');
      hiddenElement.after(hiddenElement.clone());

      const newHiddenElement = $('#client_work_centers_attributes_' + elementId + '_id').last();
      newHiddenElement.attr('id', 'client_work_centers_attributes_' + elementId + '_deleted')
                     .attr('name', 'client[work_centers_attributes][' + elementId + '][deleted]')
                     .attr('value', '1');
    });

  // Initial calculations
  set_total_time();
}

// Function to add a new form container (MISSING - ADD THIS BACK)
function add_new_form_container() {
  formCounter++;

  const $templateForm = $('.work-order-form-container').first();

  if ($templateForm.length) {
    const $newForm = $templateForm.clone();

    // Don't clear select2 state - just initialize fresh
    // clearSelect2State($newForm);

    // Capture defaults from template before value reset
    const templateUserId = $templateForm.find('input[name$="[user_id]"]').val() || $templateForm.find('select[name$="[user_id]"]').val();
    const templateDefaults = {
      day: $templateForm.find('input[name*="[day]"]').val() || new Date().toISOString().slice(0, 10),
      tipus_hora: $templateForm.find('.tipus_hora_js').map(function() { return $(this).val(); }).get(),
      diets: $templateForm.find('input[name*="[diets]"]:checked').val(),
      overnight_stay_premium: $templateForm.find('input[name*="[overnight_stay_premium]"]:checked').val(),
      vehicle_type: $templateForm.find('input[name*="[vehicle_type]"]').val(),
      desplaçament: $templateForm.find('input[name*="[desplaçament]"]').val(),
      mileage: $templateForm.find('input[name*="[mileage]"]').val(),
      concepte_despesa: $templateForm.find('input[name*="[concepte_despesa]"]').val(),
      import_despesa: $templateForm.find('input[name*="[import_despesa]"]').val(),
      prima_torn: $templateForm.find('input[name*="[prima_torn]"]').prop('checked'),
      prima_averia: $templateForm.find('input[name*="[prima_averia]"]').prop('checked'),
      prima_festiu: $templateForm.find('input[name*="[prima_festiu]"]').prop('checked')
    };

    // Clean up any Select2 artifacts cloned with the form
    $newForm.find('.select2-container, .select2, .select2-dropdown').remove();
    $newForm.find('[data-select2-id]').removeAttr('data-select2-id');
    $newForm.find('select').each(function() {
      const $sel = $(this);
      if ($sel.hasClass('select2-hidden-accessible') || $sel.data('select2')) {
        try { $sel.select2('destroy'); } catch (e) { /* ignore if not initialized */ }
      }
      $sel.removeClass('select2-hidden-accessible');
      $sel.removeClass('select2');
      $sel.removeAttr('data-select2-id tabindex aria-hidden');
      $sel.removeData('select2');
    });

    // Reset work order items - remove all existing and add one empty
    // Find the container that has work order items (contains work-order-item-form)
    const $workOrderContainer = $newForm.find('.custom-crud-body-form').filter(function() {
      return $(this).find('.work-order-item-form').length > 0;
    }).first();

    if ($workOrderContainer.length) {
      // Remove all existing work-order-item-form divs
      $workOrderContainer.find('.work-order-item-form').remove();

      // Add one empty work-order-item-form
      const $templateItem = $templateForm.find('.work-order-item-form').first();
      if ($templateItem.length) {
        const $newItem = $templateItem.clone();

        // Clear all values in the new item
        $newItem.find('input, select, textarea').val('');
        $newItem.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);

        // Reset tipus_hora to first option
        const $tipusHora = $newItem.find('.tipus_hora_js');
        if ($tipusHora.length && $tipusHora.find('option').length > 0) {
          $tipusHora.val($tipusHora.find('option').first().val());
        }

        // Update the item index
        updateWorkOrderItemRowIndex($newItem, 0);

        // Insert the new item after the title
        $workOrderContainer.find('.custom-crud-red-title').after($newItem);
      }

      // Reset total hours calculation to 0
      $workOrderContainer.find('.total-hores-calc._js').text('0h 00m');
    }

    // Update form ID
    $newForm.attr('id', `work_order_form_${formCounter}`);

    // Clear all input values EXCEPT radio buttons, checkboxes, and select (selects will be initialized by Select2)
    $newForm.find('input:not([type="submit"]):not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea').val('');

    // Set cloned form defaults for cloned copy (preserve original workflow defaults)
    $newForm.find('input[name*="[day]"]').val(templateDefaults.day);

    // Reset tipus_hora values based on template form
    $newForm.find('.tipus_hora_js').each(function(index) {
      const $tipus = $(this);
      const templateTipusValue = templateDefaults.tipus_hora[index];
      if (templateTipusValue !== undefined) {
        $tipus.val(templateTipusValue).trigger('change');
      }
    });

    // Set numeric / text defaults from template
    $newForm.find('input[name*="[desplaçament]"]').val(templateDefaults.desplaçament || '0.0');
    $newForm.find('input[name*="[mileage]"]').val(templateDefaults.mileage || '');
    
    // Set expense fields - look more specifically in hideable-content
    const $concepteField = $newForm.find('.hideable-content input[name*="[concepte_despesa]"]');
    const $importField = $newForm.find('.hideable-content input[name*="[import_despesa]"]');
    
    if ($concepteField.length) {
      $concepteField.val(templateDefaults.concepte_despesa || '');
    } else {
      $newForm.find('input[name*="[concepte_despesa]"]').val(templateDefaults.concepte_despesa || '');
    }
    
    if ($importField.length) {
      $importField.val(templateDefaults.import_despesa || '0.0');
    } else {
      $newForm.find('input[name*="[import_despesa]"]').val(templateDefaults.import_despesa || '0.0');
    }

    // Checkbox defaults from template
    $newForm.find('input[name*="[prima_torn]"]').prop('checked', templateDefaults.prima_torn);
    $newForm.find('input[name*="[prima_averia]"]').prop('checked', templateDefaults.prima_averia);
    $newForm.find('input[name*="[prima_festiu]"]').prop('checked', templateDefaults.prima_festiu);

    // Update IDs
    $newForm.find('[id]').each(function() {
      const $el = $(this);
      const oldId = $el.attr('id');
      if (oldId && !oldId.includes('_batch_')) {
        $el.attr('id', `${oldId}_batch_${formCounter}`);
      }
    });

    // Update for attributes
    $newForm.find('[for]').each(function() {
      const $el = $(this);
      const oldFor = $el.attr('for');
      if (oldFor && !oldFor.includes('_batch_')) {
        $el.attr('for', `${oldFor}_batch_${formCounter}`);
      }
    });

    // Update name attributes for batch submission
    $newForm.find('[name]').each(function() {
      const $el = $(this);
      const oldName = $el.attr('name');
      if (oldName && oldName.startsWith('work_order') && $el.attr('type') !== 'submit') {
        $el.attr('name', oldName.replace(/^work_order/, `work_orders[${formCounter}]`));
      }
    });

    // Add remove button
    const $header = $newForm.find('.custom-crud-header .row .col-12.col-md-auto.text-right');
    if ($header.length && !$header.find('.remove-work-order-form').length) {
      $header.prepend(`
        <button type="button" class="btn btn-danger remove-work-order-form mr-2" title="Eliminar">
          <i class="fa fa-trash"></i> Eliminar
        </button>
      `);
    }

    // Insert the new form without heavy animation
    $newForm.insertAfter($('.work-order-form-container').last()).show();

    // Initialize Select2 immediately after insertion
    initializeWorkOrderSelect2($newForm);

    // Preserve user_id for cloned forms after select2 init
    if (templateUserId) {
      const $userSelect = $newForm.find('select[name$="[user_id]"]');
      const $userHidden = $newForm.find('input[name$="[user_id]"]');

      if ($userSelect.length) {
        $userSelect.val(templateUserId);
        if (typeof $.fn.select2 === 'function' && $userSelect.hasClass('select2-hidden-accessible')) {
          $userSelect.trigger('change.select2');
        } else {
          $userSelect.trigger('change');
        }
      }
      if ($userHidden.length) {
        $userHidden.val(templateUserId);
      }
    }

    // Rebind client data loading for project dropdown
    bindProjectChange($newForm);

    // Ensure all existing forms still have proper event bindings
    $('.work-order-form-container').not($newForm).each(function() {
      bindProjectChange($(this));
      initializeWorkOrderSelect2($(this));
    });

    // Notify categories handler to initialize selects in the cloned form
    $(document).trigger('work-order-form-added', [$newForm]);

    cacheForms();
  }
}

function initializeWorkOrderSelect2($container) {
  // Initialize select2 for cloned forms using the same logic as the original initialization
  $container.find('.selectized').each(function() {
    const $sel = $(this);
    if (!$sel.hasClass('select2-hidden-accessible') && !$sel.data('select2')) {
      try {
        $sel.select2();
        // Use requestAnimationFrame to avoid forced reflow and ensure proper width
        requestAnimationFrame(() => {
          $sel.trigger('change.select2');
          // Ensure proper width for cloned elements
          const $select2Container = $sel.next('.select2-container');
          if ($select2Container.length) {
            $select2Container.css('width', '100%');
            $select2Container.find('.select2-selection').css('width', '100%');
          }
        });
      } catch (e) {
        // Error initializing select2 - silently fail
      }
    }
  });

  $container.find('.selectized-users, .selectized-clients, .wo-project-select, .user-dropdown').each(function() {
    const $sel = $(this);
    if (!$sel.hasClass('select2-hidden-accessible') && !$sel.data('select2')) {
      try {
        $sel.select2({
          minimumInputLength: 2,
          allowClear: true,
          placeholder: "Seleccionar opció"
        });
        // Use requestAnimationFrame to avoid forced reflow and ensure proper width
        requestAnimationFrame(() => {
          $sel.trigger('change.select2');
          // Ensure proper width for cloned elements
          const $select2Container = $sel.next('.select2-container');
          if ($select2Container.length) {
            $select2Container.css('width', '100%');
            $select2Container.find('.select2-selection').css('width', '100%');
          }
        });
      } catch (e) {
        // Error initializing select2 - silently fail
      }
    }
  });
}

function updateProjectClient($select) {
  const projectId = $select.val();
  const $container = $select.closest('.work-order-form-container');
  const $clientName = $container.find('.wo-client-col:nth-child(1) .wo-client-value');
  const $projectRef = $container.find('.wo-client-col:nth-child(2) .wo-client-value');
  const $workCenter = $container.find('.wo-client-col:nth-child(3) .wo-client-value');

  loadProjectData(projectId, $clientName, $projectRef, $workCenter);
}

function bindProjectChange($container) {
  $container.find('select.wo-project-select')
    .off('change.project select2:select.project')
    .on('change.project', function() {
      updateProjectClient($(this));
    })
    .on('select2:select.project', function() {
      updateProjectClient($(this));
    });
}

/*
// Function to reinitialize time fields
function reinitializeTimeFields($container) {
  // Rebind any time-related events
  $container.find('.time_work_order').each(function() {
    // Remove any existing event listeners (if using a specific time plugin)
    $(this).off('change').on('change', scheduleValidation);
  });

  // Reinitialize any date pickers
  $container.find('input[type="date"]').each(function() {
    // If using a custom date picker plugin, reinitialize it here
    // For native date inputs, no action needed
  });
}
*/

// Update the updateNestedIds function to handle select elements better
function updateNestedIds($container, counter) {
  // Update IDs and for attributes
  $container.find('[id]').each(function() {
    const $el = $(this);
    const oldId = $el.attr('id');
    if (oldId && !oldId.includes('_batch_')) {
      const newId = `${oldId}_batch_${counter}`;
      $el.attr('id', newId);

      // Also update any data attributes that might reference this ID
      if ($el.data('target')) {
        $el.data('target', $el.data('target').replace(oldId, newId));
      }
    }
  });

  // Update for attributes (labels)
  $container.find('[for]').each(function() {
    const $el = $(this);
    const oldFor = $el.attr('for');
    if (oldFor && !oldFor.includes('_batch_')) {
      $el.attr('for', `${oldFor}_batch_${counter}`);
    }
  });

  // Update name attributes for form inputs
  $container.find('[name]').each(function() {
    const $el = $(this);
    const oldName = $el.attr('name');

    // Skip if already processed or if it's a submit button
    if ($el.attr('type') === 'submit') return;

    if (oldName && oldName.startsWith('work_order')) {
      // Handle both regular fields and nested attributes
      const newName = oldName.replace(/^work_order/, `work_orders[${counter}]`);
      $el.attr('name', newName);

      // Also update any data attributes that might reference this name
      if ($el.data('name')) {
        $el.data('name', newName);
      }
    }
  });
}

// Helper function for translations if not available
function t(key) {
  // This is a simple fallback - you might want to implement proper translation lookup
  const translations = {
    'app_btns.remove': 'Eliminar'
  };
  return translations[key] || key;
}

function loadProjectData(projectId, $clientNameEl, $projectRefEl, $workCenterEl) {
  if (!projectId) {
    $clientNameEl.text('-');
    $projectRefEl.text('-');
    $workCenterEl.text('-');
    return;
  }

  // Try multiple approaches to get the data
  $.ajax({
    url: `/projects/${projectId}/get_project.json`,
    type: 'GET',
    dataType: 'json',
    headers: {
      'Accept': 'application/json'
    },
    success: function(project) {
      if (project) {
        $clientNameEl.text(project.client_name || project.client ? project.client.name : '-');
        $projectRefEl.text(project.reference || '-');
        $workCenterEl.text(project.work_center_name || (project.work_center ? project.work_center.name : '-'));
      }
    },
    error: function(xhr, status, error) {
      console.error('Error loading project data:', error);
      // Try fallback method - extract from DOM or use another endpoint
      fallbackLoadProjectData(projectId, $clientNameEl, $projectRefEl, $workCenterEl);
    }
  });
}

function fallbackLoadProjectData(projectId, $clientNameEl, $projectRefEl, $workCenterEl) {
  $.ajax({
    url: '/projects/search.json',
    type: 'GET',
    dataType: 'json',
    data: {
      id: projectId,
      format: 'json'
    },
    headers: {
      'Accept': 'application/json'
    },
    success: function(projects) {
      const project = Array.isArray(projects) ? projects.find(p => p.id == projectId) : projects;
      if (project) {
        $clientNameEl.text(project.client_name || project.client ? project.client.name : '-');
        $projectRefEl.text(project.reference || '-');
        $workCenterEl.text(project.work_center_name || (project.work_center ? project.work_center.name : '-'));
      } else {
        $clientNameEl.text('-');
        $projectRefEl.text('-');
        $workCenterEl.text('-');
      }
    },
    error: function() {
      // If all else fails, set to placeholder
      $clientNameEl.text('-');
      $projectRefEl.text('-');
      $workCenterEl.text('-');
    }
  });
}

// Helper function to parse combined time string "HH:MM" into hours and minutes
function parseCombinedTime(timeString) {
  if (!timeString) return { hours: 0, minutes: 0 };

  const [hours, minutes] = timeString.split(':').map(Number);
  return { hours: hours || 0, minutes: minutes || 0 };
}

function get_mins(parent_node) {
  const $parent = $(parent_node);

  // Get the combined time values
  const entranceTime = $parent.find('.entrance_time_combined_js').val();
  const departureTime = $parent.find('.departure_time_combined_js').val();

  // Check if both required fields are filled
  const filled = entranceTime && departureTime;

  if (filled) {
    const e_time = parseCombinedTime(entranceTime);
    const d_time = parseCombinedTime(departureTime);

    // Convert to minutes since midnight
    const entranceTotal = e_time.hours * 60 + e_time.minutes;
    let departureTotal = d_time.hours * 60 + d_time.minutes;

    // Handle overnight case
    if (departureTotal <= entranceTotal) {
      departureTotal += 24 * 60;
    }

    return departureTotal - entranceTotal;
  }
  return 0;
}

function updateWorkOrderItemRowIndex($row, newIndex) {
  $row.find('input[name], select[name], textarea[name]').each(function() {
    const $el = $(this);
    const name = $el.attr('name');

    if (name && name.match(/work_order_items_attributes\]\[\d+\]/)) {
      const newName = name.replace(/(work_order_items_attributes\]\[)(\d+)(\]\[.*)/, `$1${newIndex}$3`);
      $el.attr('name', newName);
    }

    const id = $el.attr('id');
    if (id && id.match(/work_order_items_attributes_\d+_/)) {
      const newId = id.replace(/(work_order_items_attributes_)\d+(_.*)/, `$1${newIndex}$2`);
      $el.attr('id', newId);
    }
  });

  $row.find('label[for]').each(function() {
    const $label = $(this);
    const forId = $label.attr('for');
    if (forId && forId.match(/work_order_items_attributes_\d+_/)) {
      const newFor = forId.replace(/(work_order_items_attributes_)\d+(_.*)/, `$1${newIndex}$2`);
      $label.attr('for', newFor);
    }
  });
}

function add_new_input_row(target_klass, html_name, $context) {
  const $container = $context || $(document);

  const formSets = {
    'work-center': 'work-center-item-form',
    'work-order': 'work-order-item-form'
  };

  const $existingForms = $container.find("." + formSets[target_klass]);
  const id = $existingForms.length;
  const $form = $container.find(`.${target_klass}-item-form`).last();

  if (!$form.length) {
    return;
  }

  const $newForm = $form.clone(false, false);

  // Clean up any cloned Select2 markup and attributes in the new row
  $newForm.find('.select2-container, .select2-dropdown, .select2-selection, .select2-selection__rendered, .select2-selection__arrow, .select2-selection__clear, .select2-search, .select2-search__field, .select2-results, .select2-results__options').remove();
  $newForm.find('[data-select2-id]').removeAttr('data-select2-id');
  $newForm.find('[aria-labelledby]').removeAttr('aria-labelledby');
  $newForm.find('select').each(function() {
    const $sel = $(this);
    $sel.removeClass('select2-hidden-accessible select2');
    $sel.removeAttr('tabindex aria-hidden style data-select2-id');
    $sel.removeData('select2');
    if (typeof $.fn.select2 === 'function' && $sel.data('select2')) {
      try { $sel.select2('destroy'); } catch (e) { /* ignore if not initialized */ }
    }
  });

  const fieldSets = {
    'work-center': ['name', 'distance'],
    'work-order': ['entrance_time_combined', 'departure_time_combined', 'description', 'tipus_hora']
  };

  const klasses = fieldSets[target_klass] || [];

  klasses.forEach(val => {
    const $input = $newForm.find(`.${val}_js`);
    $input.val('').removeClass('is-invalid');

    if (val === 'tipus_hora') {
      const $firstSelect = $container.find(`.${val}_js`).first();
      if ($firstSelect.length) {
        $input.val($firstSelect.val());
      }
    }
  });

  if (target_klass === 'work-order') {
    updateWorkOrderItemRowIndex($newForm, id);
  }

  $newForm.insertAfter($form).show();

  // Recalculate form-level totals immediately
  const $formContainer = $newForm.closest('.work-order-form-container');
  scheduleValidation($formContainer);

  cacheForms();
}

function validate_work_hours() {
  let showWarning = false;

  $('.work-order-item').each(function() {
    const $item = $(this);

    // Get times from data attributes instead of form inputs
    const entranceHour = parseInt($item.data('entrance-hour')) || 0;
    const departureHour = parseInt($item.data('departure-hour')) || 0;
    const hourTypeText = $item.data('tipus-hora'); // Get the text value

    // Convert tipus_hora text to numeric value
    let hourType = 0;
    if (hourTypeText === 'night_festive') {
      hourType = 1;
    } else if (hourTypeText === 'desplaçament') {
      hourType = 2;
    }

    // Check if outside working hours AND invalid type
    const isOutsideHours = (entranceHour >= WORK_HOURS_CONFIG.endHour ||
                          entranceHour < WORK_HOURS_CONFIG.startHour) ||
                         (departureHour > WORK_HOURS_CONFIG.endHour ||
                          departureHour < WORK_HOURS_CONFIG.startHour);

    if (isOutsideHours && WORK_HOURS_CONFIG.allowedTypes.includes(hourType)) {
      showWarning = true;
      $item.addClass('border border-danger');
      $item.find('.tipus_hora_js').addClass('text-danger');
    }
  });

  if (showWarning) {
    alert(WORK_HOURS_CONFIG.warningMessage);
  }
}

// Call this when the page loads
$(document).ready(function() {
  validate_work_hours();

  // Bind project change events for all existing forms
  $('.work-order-form-container').each(function() {
    bindProjectChange($(this));
  });

  // Initialize existing total counters
  set_total_time();
});
